/**
 * Custom form validation class
 */

class BluemindsFormValidator {
    constructor (form, rules, settings = {}) {
        if (typeof form === 'undefined' || form === null) { throw new Error('Please provide form in order to validate'); }
        if (typeof rules === 'undefined' || rules === null) { throw new Error('Please provide rules in orde to validate'); }


        let defaultSettings = {
            showErrorsInFields: {
                enabled: true,
                type: 'default'     // 'default' is Bootstrap 5 default (kleine rode tekst onder de velden). 'popover' zorgt ervoor dat de error in een popover komt bij het veld
            },
            showErrorSummary: {
                enabled: false,
                headerText: '<p>Het ingevulde formulier is niet correct ingevuld:</p>'
            }
        }

        this.settings = {
            showErrorsInFields: {
                ...defaultSettings.showErrorsInFields, ...settings.showErrorsInFields
            },
            showErrorSummary: {
                ...defaultSettings.showErrorSummary, ...settings.showErrorSummary
            }
        }


        this.form = form;
        this.rules = rules;
        this.valid = true;
        this.invalidInputs = [];
        this.invalidMessages = [];
        this.popovers = [];
    }

    setRules (rules) {
        this.rules = rules;
    }

    /**
     * Function to validate all form elements provided in rules object
     */
    validate() {
        // herstellen alle gevalideerde velden
        this.resetFormValidation();

        if (Object.keys(this.rules).length > 0) {
            Object.keys(this.rules).forEach(key => {
                /**
                 * store input associated with rule
                 * this could potentially be more than 1 input in case of radio buttons
                 */
                let input = this.form.querySelector('[name="' + key + '"]');
                if (input) {
                    this.validateInput(input, this.rules[key]);
                }
            });
        }

        // after we check validation rules we check if there are any other .is-invalid elements present in form
        let additionalInvalidFields = this.form.querySelectorAll('.is-invalid');
        if (additionalInvalidFields.length) {
            this.valid = false;
        }

        if (this.settings.showErrorsInFields.enabled && this.settings.showErrorsInFields.type == 'popover') {
            // Voor alle popovers hidden maken als het veld nu niet meer hidden is
            // Deze functionaliteit zat eerst in resetFormValidation maar dan krijg je snel hide en show na elkaar en dit werkt onvoorspelbaar
            for (var key in this.popovers) {
                let popover = this.popovers[key];
                if (!popover._element.classList.contains('is-invalid')) {
                    this.popovers[key].hide();
                }
            }
        }

        if (this.settings.showErrorSummary.enabled) {
            let validationSummary = this.form.querySelector('[data-hook="validationSummary"]');
            if (validationSummary) {
                if (this.invalidMessages.length > 0) {
                    let validationSummaryHtml = this.settings.showErrorSummary.headerText;
                    validationSummaryHtml += '<ul>';
                    this.invalidMessages.forEach(message => {
                        validationSummaryHtml += `<li>${message}</li>`;
                    });
                    validationSummaryHtml += '</ul>';
                    validationSummary.innerHTML = validationSummaryHtml;
                    validationSummary.style.display = '';
                } else {
                    validationSummary.style.display = 'none';
                }
            }
        }

        return this.valid;
    }

    /**
     * Function to reset validation on form; invalid classes, etc.
     */
    resetFormValidation() {
        this.valid = true;
        this.invalidInputs = [];
        this.invalidMessages = [];

        // remove invalid classes from form inputs
        let elements = this.form.querySelectorAll('input, select, label, textarea');
        elements.forEach(element => {
            element.classList.remove('is-invalid');
            element.parentNode.classList.remove('is-invalid');
        });

        this.form.querySelectorAll('.blueminds_form_validation-error_message').forEach(elem => {
            elem.remove();
        });

        if (this.settings.showErrorsInFields.enabled && this.settings.showErrorsInFields.type == 'default') {
            this.form.querySelectorAll('.invalid-feedback').forEach(elem => {
                elem.remove();
            });
        }


    }

    validateInput(input, rules)
    {
        // store rule keys to iterate through but also for future reference
        let inputRuleKeys = Object.keys(rules);
        inputRuleKeys.forEach(rule => {
            // to prevent invalidating and revalidating for multiple cases in validation we check if form not already is invalid
            if (this.invalidInputs.includes(input.getAttribute('name'))) { return true; }

            // in case one of following keys is found we skip since these are additional parameters
            if (['additionalFieldsInvalid', 'message'].includes(rule)) { return true; }

            // get rule value
            let value = rules[rule];

            // store potential invalid message
            let message = '';
            if ('message' in rules) {
                message = rules['message'];
            }

            // check if value is function
            if (typeof value === 'function') {
                // when is function get the actual value
                value = value();
            }

            // determine action according to rule
            switch (rule) {
                case 'required':
                    this.handleRequired(input, value, message);
                    break;
                case 'remote':
                    /** For remote we use an Ajax style configuration to perform build-in converter function ajax() */
                    this.handleRemote(input, value, message);
                    break;
                case 'email':
                    this.handleEmail(input, value, message);
                    break;
                case 'conditional':
                    this.handleConditional(input, value);
                    break;
            }
        });
    }

    handleRequired(input, value, message)
    {
        // when required, check if rule is set to true and input value is not empty
        switch (input.getAttribute('type')) {
            case 'checkbox':
            case 'radio':
                // in case of radio or checkboxes there could potentially be more than 1 input containing the same name
                let elements = this.form.querySelectorAll('[name="' + input.getAttribute('name') + '"]');
                // we also need check if one of the radios or checkboxes is checked
                let elementsChecked = this.form.querySelector('[name="' + input.getAttribute('name') + '"]:checked');

                if (value && elementsChecked === null) {
                    this.invalidateInput(elements, input.getAttribute('name'), message);
                }
                break;
            default:
                if (value && !input.value) {
                    this.invalidateInput(input, input.getAttribute('name'), message);
                }
                break;
        }
    }

    handleRemote(input, value, message)
    {
        // check if input value is not empty otherwise it makes no sense to check remote
        if (input.value) {
            let remoteResponse = ajax(value);
            remoteResponse.then(Promise => {
                if (typeof Promise === 'string' || Promise instanceof String) {
                    this.invalidateInput(input, input.getAttribute('name'), Promise);
                } else if (typeof Promise === "boolean") {
                    if (!Promise) {
                        this.invalidateInput(input, input.getAttribute('name'), message);
                    }
                } else {
                    this.invalidateInput(input, input.getAttribute('name'), 'Something went wrong, please try again.');
                }
            });
        }
    }

    handleEmail(input, value, message)
    {
        if (input.value) {
            // when input not empty we hold input against a regex
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(String(input.value).toLowerCase())) {
                this.invalidateInput(input, input.getAttribute('name'), message || 'This is not a valid email address input');
            }
        }
    }

    handleConditional(input, response)
    {
        if (response.success === false) {
            this.invalidateInput(input, input.getAttribute('name'), response.message);
        }
    }

    invalidateInput(object, name, message = null)
    {
        this.valid = false;
        this.invalidInputs.push(name);

        if (NodeList.prototype.isPrototypeOf(object))
        {
            object.forEach(node => {
                node.classList.add('is-invalid');
                this.invalidateLabel(node);

                if (message !== null) {
                    this.handleInvalidMessage(node, message);
                }
            });
        } else {
            object.classList.add('is-invalid');
            this.invalidateLabel(object);

            if (message !== null) {
                this.handleInvalidMessage(object, message);
            }
        }

        if (this.rules[name] && 'additionalFieldsInvalid' in this.rules[name]) {
            this.rules[name].additionalFieldsInvalid.forEach(field => {
                let node = this.form.querySelector('[name="' + field + '"]');
                this.invalidateInput(node, field, message);
            });
        }
    }

    invalidateLabel(node)
    {
        let parentNode = node.closest('.form-item');
        if (parentNode) {
            let label = parentNode.querySelector('label');
            if (label) {
                label.classList.add('is-invalid');
            }
        }
    }

    handleInvalidMessage(input, message)
    {
        // skip message when input is hidden
        if (input.getAttribute('type') === 'hidden') { return true; }

        if (this.settings.showErrorsInFields.enabled) {

            if (this.settings.showErrorsInFields.type == 'default') {
                const errorDiv = document.createElement('div');
                errorDiv.classList.add('invalid-feedback');
                errorDiv.textContent = message;
                // Plaats error div na input
                input.parentNode.insertBefore(errorDiv, input.nextSibling);
            }

            if (this.settings.showErrorsInFields.type == 'popover') {
                if (this.popovers[input.name] == undefined) {
                    let placement = 'top';
                    if (input.getAttribute('data-bs-placement') !== null) {
                        placement = input.getAttribute('data-bs-placement');
                    }

                    this.popovers[input.name] = new bootstrap.Popover(input, {
                        customClass: 'invalid-popover',
                        content: message,
                        trigger: 'manual',        // Other options: 'hover', 'focus', 'manual'
                        placement: placement,      // top, bottom, left, right, auto
                        container: 'body'
                    })
                }

                // Als popover all wordt getoond is tip gevuld met het DOM element van de popover
                // In dit geval willen we show niet opnieuw aanroepen omdat er anders een lelijke animatie glitch zichtbaar is
                if (this.popovers[input.name].tip == null) {
                    this.popovers[input.name].show();
                }

            }
        }

        this.invalidMessages.push(message);



    }
}